import { render, staticRenderFns } from "./TheLessonEdit.vue?vue&type=template&id=3bee51be&"
import script from "./TheLessonEdit.vue?vue&type=script&lang=js&"
export * from "./TheLessonEdit.vue?vue&type=script&lang=js&"
import style0 from "./TheLessonEdit.vue?vue&type=style&index=0&id=3bee51be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports